import { Module, VuexModule, getModule, MutationAction, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { Choice as ChoiceModel } from '@/store/models';
import ChoiceService from '@/services/ChoiceService';

@Module({
	dynamic: true,
	name: 'choice',
	store,
})
class Choice extends VuexModule {
	public choices: ChoiceModel[] = [];
	public choice: Array<string | number> = [''];

	@Mutation
	public setChoice(choice: Array<string | number>) {
		this.choice = choice;
	}

	@MutationAction
	public async loadChoices(questionId: number) {
		const choices = await ChoiceService.getInstance().getChoicesForQuestion(questionId);
		// this.setNextQuestionInChoices();
		return { choices };
	}

	@Mutation
	public resetChoices() {
		this.choices = [];
	}
}

export const ChoiceModule = getModule(Choice);
